import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="pricing"
export default class extends Controller {
  change({ target }) {
    this.dispatch("change", {
      detail: {
        cycle: target.checked ? "yearly" : "monthly",
      },
    });
  }
}
